import Api from 'requestapijs';
import {
  AddPhysicalStockVariable,
  KhadiPhysicalStockNode,
  KhadiStockObject,
  PhysicalStockMutation,
  PhysicalStockNode,
  StockObject,
} from '../components/PhysicalStock/Constants';
import { API_URL, HEADER } from '../config';

export class PhysicalStockService {
  static instance: PhysicalStockService;
  constructor() {
    if (PhysicalStockService.instance) {
      return PhysicalStockService.instance;
    } else {
      PhysicalStockService.instance = this;
    }
  }

  addPhysicalStock(
    data: PhysicalStockNode,
    onSuccess: (response) => void,
    onError: (response) => void,
  ) {
    const stockObj: StockObject[] = [];
    data.productDetails?.forEach((el, index) => {
      stockObj.push({
        productId: el.productId,
        availableStock: el.quantity,
        physicalStock: data.physicalStocks?.[index],
      });
    });
    delete data.productDetails;
    delete data.physicalStocks;

    Api.graphql<AddPhysicalStockVariable, {}>(
      API_URL,
      {
        input: {
          value: {
            ...data,
            stockObj,
          },
        },
      },
      PhysicalStockMutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      onError,
    );
  }

  addKhadiPhysicalStock(
    data: KhadiPhysicalStockNode,
    onSuccess: (response) => void,
    onError: (response) => void,
  ) {
    const stockObj: KhadiStockObject[] = [];
    data.productDetails?.forEach((el, index) => {
      stockObj.push({
        productId: el.productId,
        availableStock: el.quantity,
        physicalStock: data.physicalStocks?.[index],
        stockRemarks: el.stockRemarks,
      });
    });
    delete data.productDetails;
    delete data.physicalStocks;

    Api.graphql<AddPhysicalStockVariable, {}>(
      API_URL,
      {
        input: {
          value: {
            ...data,
            stockObj,
          },
        },
      },
      PhysicalStockMutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      onError,
    );
  }
}
